import {
  USER_PERMISSIONS_STORAGE_KEY,
  USER_COUNTRY_STORAGE_KEY,
  USER_LOCALE_STORAGE_KEY,
  USER_DEPOSIT_BALANCE_ENABLED_STORAGE_KEY,
} from '~/shared/config/constants'
import { storageGet, storageRemove, storageSet } from '~/shared/lib/storage'
import {
  Country,
  Permissions,
  UserOptionsMe,
  UserOptionsStoreType,
  Locale,
} from './types'

export class UserOptionsStore implements UserOptionsStoreType {
  private readonly storageKeyPermissions = USER_PERMISSIONS_STORAGE_KEY
  private readonly storageKeyLocale = USER_LOCALE_STORAGE_KEY
  private readonly storageKeyCountry = USER_COUNTRY_STORAGE_KEY
  private readonly storageKeyDepositBalanceEnabled =
    USER_DEPOSIT_BALANCE_ENABLED_STORAGE_KEY

  private fallbackPermissions: Permissions = null
  private fallbackLocale: Locale = null
  private fallbackCountry: Country = null
  private fallbackDepositBalanceEnabled: boolean | null = null

  get permissions(): Permissions {
    const storageByKey = storageGet<Permissions>(this.storageKeyPermissions)

    return this.fallbackPermissions || storageByKey
  }
  get locale(): Locale {
    const storageByKey = storageGet<Locale>(this.storageKeyLocale)

    return this.fallbackLocale || storageByKey
  }
  get country(): Country {
    const storageByKey = storageGet<Country>(this.storageKeyCountry)

    return this.fallbackCountry || storageByKey
  }

  get depositBalanceEnabled(): boolean {
    const storageByKey = storageGet<boolean>(
      this.storageKeyDepositBalanceEnabled,
    )

    return this.fallbackDepositBalanceEnabled ?? storageByKey ?? false
  }

  save(options: UserOptionsMe) {
    const { permissions, taxipark, locale } = options
    const depositBalanceEnabled = options.depositBalanceEnabled ?? false

    const country = taxipark?.country || null

    storageSet<Permissions>(this.storageKeyPermissions, permissions)
    storageSet<Locale>(this.storageKeyLocale, locale)
    storageSet<Country>(this.storageKeyCountry, country)
    storageSet<boolean>(
      this.storageKeyDepositBalanceEnabled,
      depositBalanceEnabled,
    )

    this.fallbackPermissions = permissions
    this.fallbackLocale = locale
    this.fallbackCountry = country
    this.fallbackDepositBalanceEnabled = depositBalanceEnabled
  }

  clear() {
    storageRemove(this.storageKeyPermissions)
    storageRemove(this.storageKeyDepositBalanceEnabled)

    this.fallbackPermissions = null
    this.fallbackCountry = null
    this.fallbackDepositBalanceEnabled = null
  }
}
